<template>
	<v-card v-show="showSumResults">
		<!-- Total amounts -->
		<v-layout row wrap>
			<v-flex xs12 sm10 offset-sm1 md6 offset-md3 lg4 offset-lg4>
				<!-- Expandable -->
				<v-expansion-panels>
					<v-expansion-panel class="expansionPanel">

					<v-list dense>
						<v-list-item>
							<v-list-item-content><b>{{txt.summary}}</b></v-list-item-content>
						</v-list-item>
						<strong>
						<v-list-item>
							<v-list-item-content>{{txt.sum.issuedGuestcardsNr}}:</v-list-item-content>
							<v-list-item-content class="align-end">{{ formattedGuestCardTotal }}</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content>{{txt.sum.guestsNr}}:</v-list-item-content>
							<v-list-item-content class="align-end">{{ formattedGuestTotal }}</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content>{{txt.sum.formCount}}:</v-list-item-content>
							<v-list-item-content class="align-end">{{ formattedFormsTotal }}</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content>{{txt.sum.totalOvernightStays}}:</v-list-item-content>
							<v-list-item-content class="align-end">{{ formattedOvernightStays }}</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content>{{txt.sum.residenceTax}}:</v-list-item-content>
							<v-list-item-content class="align-end">{{ formattedResidenceTaxAmount }}</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content>{{txt.sum.incompleteEntries}}:</v-list-item-content>
							<v-list-item-content class="align-end">{{ formattedIncompleteEntries }}</v-list-item-content>
						</v-list-item>
						</strong>
					</v-list>

					<v-expansion-panel-header> {{txt.detailInfo}}
						<v-expansion-panel-content class="expansionFluid">
						<v-list>
							<v-divider></v-divider>
							<v-list-item>
								<v-list-item-content> {{ txt.sum.groupsCount }} :</v-list-item-content>
								<v-list-item-content class="align-end">{{ formattedGroupsCount }}</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content> {{ txt.sum.inGroupAdult }} :</v-list-item-content>
								<v-list-item-content class="align-end">{{ formattedAdultCountInGroup }}</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content> {{ txt.sum.inGroupAdolescent }} :</v-list-item-content>
								<v-list-item-content class="align-end">{{ formattedAdolescentCountInGroup }}</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content> {{ txt.sum.inGroupKids }} :</v-list-item-content>
								<v-list-item-content class="align-end">{{ formattedKidCountInGroup }}</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content> {{ txt.sum.ovenightAdult }} :</v-list-item-content>
								<v-list-item-content class="align-end">{{ formattedOvernightStaysAdultTotal }}</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content> {{ txt.sum.overnightAdolescent }} :</v-list-item-content>
								<v-list-item-content class="align-end">{{ formattedOvernightStaysAdolescentTotal }}</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content> {{ txt.sum.overnightKids }} :</v-list-item-content>
								<v-list-item-content class="align-end">{{ formattedOvernightStaysKidTotal }}</v-list-item-content>
							</v-list-item>

						</v-list>
						</v-expansion-panel-content>
					</v-expansion-panel-header>
					</v-expansion-panel>
				</v-expansion-panels>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
export default {
	name: 'RegistrationreportSumSection',
	props: {
		summedData: {
			required: true,
		},
		showSumResults: {
			required: true,
			default: false,
		},
		currency: {
			type: String,
			default: 'CHF',
		},
	},
	data() {
		return {
			txt: {
				overnightStayNr: 'Number of overnight stays',
				detailInfo: 'Detailed info',
				summary: 'Summary',
				sum: {
					issuedGuestcardsNr: 'Issued guest cards',
					guestsNr: 'Guests',
					formCount: 'Registration forms',
					totalOvernightStays: 'Overnight stays',
					groupsCount: 'Number of groups',
					inGroupAdult: 'Adults in groups',
					inGroupAdolescent: 'Adolescents in groups',
					inGroupKids: 'Kids in groups',
					ovenightAdult: 'Overnight stays adults',
					overnightAdolescent: 'Overnight stays adolescents',
					overnightKids: 'Overnight stays kids',
					residenceTax: 'Residence tax',
					incompleteEntries: 'Incomplete entries',
				},
			},
		}
	},
	methods: {
		toDecimal(value) {
			const number = parseFloat(value)
			const result = number.toFixed(2)
			return result
		},
		toCurrency(amount, currency) {
			const number = Number(amount)
			const formatter = new Intl.NumberFormat('de-DE', {
				style: 'currency',
				currency,
				minimumFractionDigits: 2,
			})
			return formatter.format(number)
		},
		toFormatNumberWithSeperators(value) {
			const nf = new Intl.NumberFormat('de-DE')
			return nf.format(value)
		},
	},
	computed: {
		formattedGuestCardTotal() {
			return this.toFormatNumberWithSeperators(this.summedData.guestcard_total)
		},
		formattedGuestTotal() {
			return this.toFormatNumberWithSeperators(this.summedData.number_of_guests)
		},
		formattedResidenceTaxAmount() {
			return this.toCurrency(this.summedData.residence_tax_amount, this.currency)
		},
		formattedOvernightStays() {
			return this.toFormatNumberWithSeperators(this.summedData.overnight_total)
		},
		formattedIncompleteEntries() {
			return this.toFormatNumberWithSeperators(this.summedData.incomplete_entries)
		},
		formattedAdultCountInGroup() {
			return this.toFormatNumberWithSeperators(this.summedData.count_adult_in_group)
		},
		formattedAdolescentCountInGroup() {
			return this.toFormatNumberWithSeperators(this.summedData.count_adolescent_in_group)
		},
		formattedKidCountInGroup() {
			return this.toFormatNumberWithSeperators(this.summedData.count_kid_in_group)
		},
		formattedOvernightStaysAdultTotal() {
			return this.toFormatNumberWithSeperators(this.summedData.overnight_adult_total)
		},
		formattedOvernightStaysAdolescentTotal() {
			return this.toFormatNumberWithSeperators(this.summedData.overnight_adolescent_total)
		},
		formattedOvernightStaysKidTotal() {
			return this.toFormatNumberWithSeperators(this.summedData.overnight_kid_total)
		},
		formattedFormsTotal() {
			return this.toFormatNumberWithSeperators(this.summedData.count_of_forms)
		},
		formattedGroupsCount() {
			return this.toFormatNumberWithSeperators(this.summedData.groups_count)
		},
	},
}
</script>

<style scoped>
.align-end{
	margin-right: -50%;
}

</style>
